import React, { useState, Dispatch } from 'react'
import { Col, Row, Input, Radio, Button, Spin, notification, Modal } from "antd"
import type { RadioChangeEvent } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { createUser } from '../../api/User/User';

const CreateUser = (props: { setShowModal: Dispatch<boolean>, showModal: boolean, setUpdateList: Dispatch<boolean> }) => {
  const { setShowModal, showModal, setUpdateList } = props
  const [radioValue, setRadioValue] = useState<string>("")
  const [loading, setLoading] = useState<boolean>(false)
  const [atlas, setAtlas] = useState<string>("")
  const [name, setName] = useState<string>("")
  const [lastname, setLastname] = useState<string>("")

  const onChange = (e: RadioChangeEvent) => {
    setRadioValue(e.target.value)
  }

  const handleValidate = async () => {
    setLoading(true)
    const res = await createUser(atlas, radioValue, name, lastname)
    if (res.status === 200) {
      // notification.info({ message: "Mot de passe: " + res.data.password, placement: "top", duration: null })
      setUpdateList(true)
    }
    setRadioValue("")
    setAtlas("")
    setName("")
    setLastname("")
    setShowModal(false)
    setLoading(false)
  }

  return (
    <Modal footer={null} open={showModal} onCancel={() => setShowModal(false)}
      afterClose={() => {
        setRadioValue("")
        setAtlas("")
        setName("")
        setLastname("")
      }}
    >
      <Spin indicator={<LoadingOutlined />} spinning={loading}>
        <div className='create-user-container'>
          <Row className='create-user-row'>
            <Col xs={24} className='create-user-atlas'>
              <Input value={atlas} onChange={(e) => setAtlas(e.target.value)} size='large' placeholder='Email' />
            </Col>
            <Col md={12} xs={24} className='create-user-lastname'>
              <Input value={lastname} onChange={(e) => setLastname(e.target.value)} size='large' placeholder='Nom' />
            </Col>
            <Col md={12} xs={24} className='create-user-firstname'>
              <Input value={name} onChange={(e) => setName(e.target.value)} size='large' placeholder='Prenom' />
            </Col>
            <Col xs={24} className='create-user-radio'>
              <Radio.Group size='large' onChange={onChange} value={radioValue} defaultValue='operator' >
                <Radio value={"user"} defaultChecked={true} className='create-user-radio-button'>Operateur</Radio>
                <Radio value={"admin"} className='create-user-radio-button'>Administrateur</Radio>
              </Radio.Group>
            </Col>
            <Col xs={24} className='create-user-radio'>
              <Button id="validate-button" className='add-user-button' onClick={handleValidate}>Valider</Button>
            </Col>
          </Row>
        </div>
      </Spin>
    </Modal>
  )
}

export default CreateUser;